import React from 'react'
import { connect } from 'react-redux'
import CardReport from './BetaCardReport'
import { requestReport } from '../../api'
import moment from 'moment'
import _ from 'lodash'
import { handleReportRequest } from '../../modules/report'
import { rateLimit } from '../../utils/rate-limit'
import { createDateRange, getUserTimezone } from '../../utils/dateUtils'
import { DateTime } from 'luxon'

// Get today's date in the user's selected timezone
const getTodayInUserTimezone = () => {
  const userTimezone = getUserTimezone()
  const now = DateTime.now().setZone(userTimezone)
  // Create moment from date components to avoid timezone conversion
  return moment({ year: now.year, month: now.month - 1, day: now.day })
}

class CardReportContainer extends React.Component {
  state = {
    walkinType: 'all',
    cardId: null,
    stationId: null,
    startDate: getTodayInUserTimezone(),
    endDate: getTodayInUserTimezone(),
    extraPrivilege: null,
    searchArchived: false,
    isLoading: false,
  }

  reportName = '/api/reports/queue/cardReportBeta'

  createQuery = (type) => {
    // Create timezone-aware date ranges using user's selected timezone
    const startRange = createDateRange(this.state.startDate)
    const endRange = createDateRange(this.state.endDate)

    return {
      type,
      walkinType: this.state.walkinType,
      cardId: this.state.cardId,
      stationId: this.state.stationId,
      extraPrivilege: this.state.extraPrivilege,
      startDate: startRange.start, // UTC ISO string
      endDate: endRange.end,       // UTC ISO string
      source: this.state.searchArchived ? 'archived' : undefined,
    }
  }

  handleFilterChange = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    })
  }

  handleDownloadPDF = async () => {
    rateLimit(
      async () =>
        await handleReportRequest(
          requestReport(this.reportName, this.createQuery('pdf')),
        ),
      3000,
      (isLoading) => {
        this.setState((state) => ({
          ...state,
          isLoading,
        }))
      },
    )
  }

  handleDownloadCSV = async () => {
    rateLimit(
      async () =>
        await handleReportRequest(
          requestReport(this.reportName, this.createQuery('csv')),
        ),
      3000,
      (isLoading) => {
        this.setState((state) => ({
          ...state,
          isLoading,
        }))
      },
    )
  }

  handleViewWebClick = () => {
    window.open(this.downloadHTMLLink(), '_blank')
  }

  downloadHTMLLink = () => {
    const url = new URL('/report/web', window.location.href)
    const query = this.createQuery()
    url.searchParams.set('name', 'cardReportBeta')
    for (const key of Object.keys(query)) {
      if (query[key]) url.searchParams.set(key, query[key])
    }
    return url.href
  }

  isDownloadable = () => {
    if (
      this.state.isLoading ||
      !this.state.startDate ||
      typeof this.state.startDate !== 'object' ||
      !this.state.endDate ||
      typeof this.state.endDate !== 'object'
    )
      return false
    return (
      this.state.startDate
        .startOf('day')
        .isBefore(this.state.endDate.endOf('day')) &&
      (this.state.walkinType === 'card' ? !_.isNil(this.state.cardId) : true)
    )
  }

  render() {
    return (
      <CardReport
        onFilterChange={this.handleFilterChange}
        onDownloadCSV={this.handleDownloadCSV}
        onDownloadPDF={this.handleDownloadPDF}
        onViewWebClick={this.handleViewWebClick}
        isDownloadable={this.isDownloadable()}
        filter={this.state}
        auth={this.props.auth}
      />
    )
  }
}

export default connect((state) => ({ auth: state.auth }))(CardReportContainer)
